import { AxiosResponse } from 'axios';
import BaseAPI from "../api";
import { pagination_list } from '../type';

const path = 'room-meeting-day';


export type room_meeting_day_data = {
    id_room_meeting: number | null;
    type_day: string;
    day_name: string;
    room_meeting_start_date: string | null;
    room_meeting_end_date: string | null;
    room_meeting_time: string;
}

export interface room_meeting_day_list extends pagination_list {
    id_room_meeting?: number;
}

export class RoomMeetingDayApi extends BaseAPI {
    static create(body: room_meeting_day_data): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_room_meeting: number, body: room_meeting_day_data): Promise<AxiosResponse> {
        return this.api.post(`${path}/${id_room_meeting}`, body)
    }
    static list(params: room_meeting_day_list): Promise<AxiosResponse> {
        return this.api.get(`${path}/list`, { params })
    }
    static delete(id_room_meeting_day: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_room_meeting_day}`);
    }
}